module.exports = __webpack_public_path__ + "img/indicator.d023b3fc.svg";